import { Gondor } from "../Gondor";

const ACTIONS = {
  CLICK: "/click",
};

export function click(params: any) {
  return Gondor.http.post(ACTIONS.CLICK, params);
}
